module.exports = __webpack_public_path__ + "static/media/fabric-firecell-notitle.209e5249.png";